import React, { Component } from 'react';
import styles from './style.module.css';

class Product extends Component {
    state = {
        height: 115,
        buttonColor: true
    };

    toggle = () => {
        const { height } = this.state;

        this.setState({
            height: height === 115 ? 'auto' : 115,
            buttonColor: !this.state.buttonColor
        });
    };
    render() {
        const { height } = this.state;
        let btnClass = this.state.buttonColor ? "learnMore" : "hideMore";

        return (
            <sector id="services">
                <div className={styles.sectionWrapper}>
                    <div className={styles.maxWidth}>
                        <div className={styles.contentWrapper + " revealClass"}>
                       <div className={styles.servicesGrid}>

  {/* COLUMN 1 */}
  <div className={styles.serviceColumn}>
    <span className={styles.serviceTitle}>Styling</span>

    <div className={styles.serviceMedia}>
      <div className={styles.imgStyling}></div>
    </div>

    <p className={styles.smallText}>
      Die La Biosthétique Styling-Produkte präsentieren sich gemäß der logischen
      Anwendungsreihenfolge vom feuchten bis zum trockenen und geföhntem Haar
      in drei optisch unterschiedlichen Gruppen.
    </p>
  </div>
    <p className={styles.smallTextM}>
      Die La Biosthétique Styling-Produkte präsentieren sich gemäß der logischen
      Anwendungsreihenfolge vom feuchten bis zum trockenen und geföhntem Haar
      in drei optisch unterschiedlichen Gruppen.
    </p>
  {/* COLUMN 2 */}
  <div className={styles.serviceColumn}>
    <span className={styles.serviceTitle}>Pflege</span>

    <div className={styles.serviceMedia}>
      <div className={styles.imgPflege}></div>
    </div>

    <p className={styles.smallText}>
      Die Haare sind der erste Schmuck des Menschen, Ausdruck von Persönlichkeit,
      Stil und Empfinden. Schöne, gesunde Haare beginnen mit einer gesunden
      Kopfhaut.
    </p>
  </div>
   <p className={styles.smallTextM}>
      Die Haare sind der erste Schmuck des Menschen, Ausdruck von Persönlichkeit,
      Stil und Empfinden. Schöne, gesunde Haare beginnen mit einer gesunden
      Kopfhaut.
    </p>
</div>
                        </div>
                    </div>
                </div >
            </sector>
        );
    }
}

export default Product;
